<template>
  <div v-if="item" class="p-8 b-counterparty-content">
    <div class="mb-8 b-counterparty-content__main-info">
      <div class="mb-2 b-counterparty-content__top">
        <h2 data-cy="content-display-name">{{item.name}}</h2>
        <button v-if="!isReadOnlyMode" data-cy="edit-button" class="b-btn  b-btn__icon_color_main-text" @click="editAsset">
          <dynamic-icon icon="edit" class="b-btn__icon"></dynamic-icon>
          {{$t('CONTENT.contract.edit')}}
        </button>
      </div>
      <div class="b-counterparty-content__info-codes-wrap mb-4">
        <div v-if="item.underlyingAssetTypeId" class="b-counterparty-content__info-codes">
          <div data-cy="content-external-id" class="b-counterparty-content__info-codes-value">{{getAssetType(item.underlyingAssetTypeId)}}</div>
        </div>
        <div class="b-counterparty-content__info-checked">
          <div data-cy="content-vgo" v-if="item.isLowValue" class="b-counterparty-content__info-checked-item">
            <dynamic-icon class="mr-2" icon="check"></dynamic-icon>
            {{$t('CONTENT.is_low_value')}}
          </div>
        </div>
      </div>
      <div class="b-counterparty-content__info-codes-wrap">
        <div v-if="item.idInDB" class="b-counterparty-content__info-codes">
          <div class="mr-2 b-counterparty-content__info-codes-name">id:</div>
          <div data-cy="content-itn" class="b-counterparty-content__info-codes-value">{{item.idInDB}}</div>
        </div>
        <div v-if="item.externalId" class="b-counterparty-content__info-codes">
          <div class="mr-2 b-counterparty-content__info-codes-name">{{$t('CONTENT.external_id')}}:</div>
          <div data-cy="content-external-id" class="b-counterparty-content__info-codes-value">{{item.externalId}}</div>
        </div>
        <div v-if="item.businessUnitId" class="b-counterparty-content__info-codes">
          <div class="mr-2 b-counterparty-content__info-codes-name">{{$t('CONTENT.assets.business_unit')}}:</div>
          <div data-cy="content-external-id" class="b-counterparty-content__info-codes-value">{{businessUnitName}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

	export default {
		props: {
			item: {
        required: true,
        default: null
      },
      isReadOnlyMode: {
        type: Boolean
      },
    },
		computed: {
			...mapGetters(['getUnderlyingAssetTypes', 'getBusinessUnits']),
      businessUnitName() {
        return this.getBusinessUnits.find(unit => unit.idInDB === this.item.businessUnitId).name;
      },
		},
    methods: {
			getAssetType(assetTypeId) {
				for (let i = 0; i < this.getUnderlyingAssetTypes.length; i++) {
					if(this.getUnderlyingAssetTypes[i].idInDb === assetTypeId) {
						return this.getUnderlyingAssetTypes[i].name;
					}
				}
			},
			editAsset() {
				this.$emit('edit');
      }
    }
	}
</script>

<style scoped>
</style>
